export { default, StyledSentiment } from './Sentiment';
export type { SentimentProps } from './Sentiment';
